const FeaturedThisWeekSkeleton = ({ viewRef }: any) => {
  return (
    <div className="my-2.5 overflow-hidden" ref={viewRef}>
      <div className="flex justify-between relative px-5">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-24 rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-20 rounded-700 skeleton" />
      </div>
      <div className="flex mx-5 mt-2.5">
        <div className="w-[146px] h-[146px] skeleton bg-surface-200-bg rounded-[15px]" />
        <div className="w-[146px] flex-1 relative pl-2.5">
          <div className="w-full h-8 skeleton bg-surface-200-bg" />
          <div className="w-full h-5 mt-1.5 skeleton bg-surface-200-bg" />
          <div className="w-[96px] text-right absolute right-0 bottom-0">
            <div className="h-7 skeleton bg-surface-200-bg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedThisWeekSkeleton;
